import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumReducer(state = initialState.verummiddleware, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMMIDDLEWARE_SUCCESS:
      return action.verummiddleware;

    default:
      return state;
  }
}
